import firebase from "services/FirebaseService";
import { dispatch } from "whiteboard/AppStore";
import find from "lodash/find";
import filter from "lodash/filter";
import reject from "lodash/reject";
import queryString from "qs";

const db = firebase.firestore();

const addTempDataMod = firebase.functions().httpsCallable("addTempDataMod");
const waitHTTP = firebase.functions().httpsCallable("wait");

const parsed = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
function getParam(name, defaultValue) {
  return parsed[name] ? parsed[name] : defaultValue;
}

const paperSizes = {
  letter: ["8.5in", "11in"],
  A4: ["210mm", "297mm"]
};

let communityFeatured_unsubscribe;
let communityRecent_unsubscribe;

const defaultState = {
  mods: [],
  paperSizes,
  currentPaperSize: getParam("size", "letter"),
  folds: getParam("folds", "top"),
  guides: getParam("guides", "off"),
  dataMods: [],
  pdfMods: [],
  communityFeatured: [],
  communityRecent: [],
  dirty: false // is editor dirty
};

const model = {
  state: defaultState,
  reducers: {
    addItem(state, { id, data, prop }) {
      const prev = find(state[prop], { id });
      if (prev) {
        return state;
      }
      let items = state[prop].slice();
      items.push({ id, ...data });
      return { ...state, [prop]: items };
    },
    addItems(state, { list, prop }) {
      const filteredList = filter(list, ({ id, data, prop }) => {
        return !find(state[prop], { id });
      }).map(({ id, data, prop }) => {
        return { id, ...data };
      });
      let items = state[prop].slice();
      items = items.concat(filteredList);
      return { ...state, [prop]: items };
    },
    updateItem(state, { id, data, prop }) {
      let items = state[prop].map(item => {
        if (item.id === id) {
          return { id, ...data };
        }
        return item;
      });
      return { ...state, [prop]: items };
    },
    removeItem(state, { id, data, prop }) {
      let items = reject(state[prop], item => {
        return item.id === id;
      });
      return { ...state, [prop]: items };
    },
    setOption(state, option) {
      return { ...state, ...option };
    },
    clearMods(state, option) {
      return {
        ...state,
        mods: [],
        dataMods: [],
        pdfMods: []
      };
    },
    "editor/insertModIntoEditorPage": (state, option) => {
      return { ...state, dirty: true };
    },
    "editor/onChangeModData": (state, option) => {
      return { ...state, dirty: true };
    },
    "editor/newEmptyMod": (state, option) => {
      return { ...state, dirty: true };
    },
    "editor/setModData": (state, option) => {
      return { ...state, dirty: false };
    }
  },
  effects: {
    async init(payload, rootState) {
      dispatch.auth.setupAuth();
      dispatch.ui.getCommunityRecent({});
      dispatch.news.init();
    },
    async logout(payload, rootState) {
      dispatch.auth.logout();
    },
    async wait(options, rootState) {
      const result = await waitHTTP(options);
      console.log(result);
    },
    async profileUpdated(profile, rootState) {
      this.clearMods();
      dispatch.ui.loadPublicUIData();
      dispatch.news.init();
      dispatch.ui.loadSavedDataMods(profile);
      dispatch.ui.loadSavedPDFMods(profile);
    },
    async loadPublicUIData(payload, rootState) {
      const prop = "mods";
      const modsRef = await db
        .collection("mods")
        .where("level", "<=", rootState.account.subscription.level)
        .onSnapshot(snapshot => {
          let addedItems = [];
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              addedItems.push({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "modified") {
              this.updateItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "removed") {
              this.removeItem({ id: change.doc.id, data: change.doc.data(), prop });
            }
          });
          this.addItems({ prop, list: addedItems });
        });
    },
    async loadSavedDataMods({ uid }, rootState) {
      const prop = "dataMods";
      const modsRef = await db
        .collection("data-mods")
        .where("uid", "==", uid)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              this.addItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "modified") {
              this.updateItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "removed") {
              this.removeItem({ id: change.doc.id, data: change.doc.data(), prop });
            }
          });
        });
    },
    async loadSavedPDFMods({ uid }, rootState) {
      const prop = "pdfMods";
      const modsRef = await db
        .collection("pdf-mods")
        .where("uid", "==", uid)
        .orderBy("createdAt", "desc")
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              this.addItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "modified") {
              this.updateItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "removed") {
              this.removeItem({ id: change.doc.id, data: change.doc.data(), prop });
            }
          });
        });
    },
    async duplicateMod({ from, to }, rootState) {
      try {
        const fromMod = await db
          .collection("mods")
          .doc(from)
          .get();
        const checkToMod = await db
          .collection("mods")
          .doc(to)
          .get();
        if (checkToMod.exists) {
          throw new Error("To mod exists");
        }
        const fromModData = fromMod.data();
        const toMod = await db
          .collection("mods")
          .doc(to)
          .set(fromModData);
        alert("Mod duplicated");
      } catch (e) {
        console.error(e);
        alert(e);
      }
    },
    async onMakePDF({ onSuccess }, rootState) {
      const book = { ...rootState.editor };
      const paperSize = rootState.ui.currentPaperSize;
      const folds = rootState.ui.folds;
      const guides = rootState.ui.guides;
      // create a mod
      try {
        const result = await addTempDataMod({ book, paperSize, folds, guides });
        console.log(result);
        onSuccess && onSuccess(result.data);
      } catch (e) {
        console.error(e);
        alert(e.message);
      }
    },
    async getCommunityRecent({}, rootState) {
      const prop = "communityRecent";
      if (communityRecent_unsubscribe) {
        communityRecent_unsubscribe();
        communityRecent_unsubscribe = undefined;
      }
      communityRecent_unsubscribe = await db
        .collection("pdf-mods")
        .where("isPublic", "==", true)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              this.addItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "modified") {
              this.updateItem({ id: change.doc.id, data: change.doc.data(), prop });
            } else if (change.type === "removed") {
              this.removeItem({ id: change.doc.id, data: change.doc.data(), prop });
            }
          });
        });
    }
  }
};

export default model;



// WEBPACK FOOTER //
// ./src/whiteboard/models/ui.js